import { useCallback } from "react";
import { useAccount, useWriteContract } from "wagmi";
import { waitForTransactionReceipt } from "@wagmi/core";
import { parseEther } from "viem";
import chinaAbi from "../../utils/chinaAbi.json";
import Environment from "../../utils/Environment";
import { wagmiConfig } from "../../wagmiConfig";
import { contractIsSpecialCodeArg } from "../../utils/specialUser";

const usePurchaseUniswape = () => {
  const { address: account, isConnected } = useAccount();
  const { writeContractAsync } = useWriteContract();

  const UsdtAdress = Environment.unisape;

  const purchaseUniswape = useCallback(
    async (amount, postApiRes, id, balance, min, stakeIndex, index, insurancePer) => {
      if (!isConnected || !account) throw new Error("WALLET_NOT_CONNECTED");

      console.log(min, "min");

      let nd;
      if (index) {
        let percecnt = parseFloat(amount) * insurancePer;
        let value = parseFloat(amount) + percecnt;
        let valueamount = parseFloat(value).toFixed(6);
        let amount1 = Math.round(valueamount * 1e12) / 1e12;
        nd = parseEther(amount1.toString());
      } else {
        let valueamount = parseFloat(amount).toFixed(6);
        let amount1 = Math.round(valueamount * 1e12) / 1e12;
        nd = parseEther(amount1.toString());
      }

      let minvalue = min * 0.99;
      minvalue = Math.round(parseFloat(minvalue).toFixed(6) * 1e12) / 1e12;
      minvalue = parseEther(minvalue.toString());

      try {
        const hash = await writeContractAsync({
          address: Environment.presaleContract,
          abi: chinaAbi,
          functionName: "purchaseTokenWithToken",
          args: [
            UsdtAdress,
            postApiRes?.normalizationFactor,
            postApiRes?.normalizationFactorNft,
            postApiRes?.price,
            nd,
            minvalue,
            postApiRes?.agentsAddresses,
            postApiRes?.agentsPercentages,
            postApiRes.code,
            id,
            postApiRes.deadline,
            contractIsSpecialCodeArg(postApiRes),
            postApiRes?.v,
            postApiRes?.r,
            postApiRes?.s,
          ],
        });

        console.log("UNI tx hash:", hash);

        const receipt = await waitForTransactionReceipt(wagmiConfig, { hash });

        console.log("UNI purchase confirmed:", receipt);

        return { transactionHash: hash, receipt };
      } catch (error) {
        console.error("UNI purchase error:", error);
        throw error;
      }
    },
    [account, isConnected, writeContractAsync]
  );

  return { purchaseUniswape };
};

export default usePurchaseUniswape;
